import request from '@/utils/axios-req'

export function apiGetNonce(wallet) {
    return request({
        url: `/api/v1/miniapp/wallet_nonce?wallet=${wallet}`,
        method: 'get',
    })
}

export function apiWalletAuth(data) {
    return request({
        url: `/api/v1/miniapp/wallet_auth`,
        method: 'post',
        data
    })
}

//bsc 链上签到
export const apiBscSign = (data) => {
    return request({
        url: `/api/v1/miniapp/task/bsc_check_in`,
        method: 'post',
        data
    })
}

//bscminit
export const postBscMintNft = (data) => {
    return request({
        url: `/api/v1/miniapp/bsc_mint`,
        method: 'post',
        data,
    })
}
//获取商城支付链接

export const apiShopPayLink = (id, wallet, is_accelerator) => {
    return request({
        url: `/api/v1/miniapp/shop/h5_pay_link?config_id=${id}&relevance=${wallet}&is_accelerator=${is_accelerator}`,
        method: 'get',
    })
}
//商城支付校验

export const apiShopPayCheck = (data) => {
    return request({
        url: `/api/v1/miniapp/shop/h5_pay_check`,
        method: 'post',
        data
    })
}

//h5修改用户全局设置
export const apiH5NsfwSetting = (id, transaction_id) => {
    return request({
        url: `/api/v1/miniapp/account/${id}/h5_nsfw_setting`,
        method: 'post',
        data: {
            transaction_id
        }
    })
}


// 获取 英雄卡牌
export const getGoogleUrl = (val, data) => {
    return request({
        url: `/api/v1/auth/${val}`,
        method: 'get',
        data
    })
}


//数字人mint
export const apiH5AgentsMint = (id, data) => {
    return request({
        url: `/api/v1/miniapp/character/${id}/bsc_mint`,
        method: 'post',
        data,
    })
}


//获取推特登录链接
export const getTwitterLogin = () => {
    return request({
        url: `/api/v1/miniapp/twitter/login`,
        method: 'get',
    })
}

//获取推特登录回调
export const getTwitterCallback = (code, state) => {
    return request({
        url: `/api/v1/miniapp/twitter/callback`,
        method: 'get',
        data: {
            code: code,
            state: state
        }
    })
}

// 再次获取推特token
export const getTwitterRefreshToken = (refresh_token) => {
    return request({
        url: `/api/v1/miniapp/twitter/refresh_token`,
        method: 'get',
        data: {
            refresh_token: refresh_token,
        }
    })
}

